import { render } from "./GaAuthView.vue?vue&type=template&id=ddb4d3ce"
import script from "./GaAuthView.vue?vue&type=script&lang=js"
export * from "./GaAuthView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__